export const MINIMAL_VERSION_NEW_PLACEMENT_RELATIONS = '0.12.0';
export const EXT_MIN_VERSION_SUPPORT_SIDEBAR = '0.40.0'; // we won't get there soon - todo update extension version
export const GET_TOKEN_FROM_EXT_KEY = 'GET_TOKEN';
export const MINIMAL_VERSION_ROUTER_GUARD_IFRAME_TOKEN = '0.18.3';
